import { render, staticRenderFns } from "./InsertBannerManage.vue?vue&type=template&id=3cf62225&"
import script from "./InsertBannerManage.vue?vue&type=script&lang=js&"
export * from "./InsertBannerManage.vue?vue&type=script&lang=js&"
import style0 from "./InsertBannerManage.vue?vue&type=style&index=0&id=3cf62225&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cf62225')) {
      api.createRecord('3cf62225', component.options)
    } else {
      api.reload('3cf62225', component.options)
    }
    module.hot.accept("./InsertBannerManage.vue?vue&type=template&id=3cf62225&", function () {
      api.rerender('3cf62225', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/contents/insert-banner-manage/InsertBannerManage.vue"
export default component.exports